import { gql, useMutation } from '@apollo/client';
import type {
  SendGeneralTransferDetailsToEmailMutation,
  SendGeneralTransferDetailsToEmailMutationVariables,
} from '../types/types';

const SEND_GENERAL_TRANSFER_DETAILS_TO_EMAIL = gql`
  mutation SendGeneralTransferDetailsToEmail($offerId: String!, $installments: Int!) {
    sendGeneralTransferDetailsToEmail(offerId: $offerId, installments: $installments)
  }
`;

/**
 * Hook to send general transfer payment details to the user's email.
 * Call with the offerId and the number of installments (1 for one-time, 12 for monthly).
 */
export function useSendGeneralTransferDetailsToEmail(): [
  (variables: SendGeneralTransferDetailsToEmailMutationVariables) => Promise<void>
] {
  const [mutate] = useMutation<
    SendGeneralTransferDetailsToEmailMutation,
    SendGeneralTransferDetailsToEmailMutationVariables
  >(SEND_GENERAL_TRANSFER_DETAILS_TO_EMAIL);

  const sendGeneralTransferDetailsToEmail = async (
    variables: SendGeneralTransferDetailsToEmailMutationVariables
  ) => {
    await mutate({ variables });
  };

  return [sendGeneralTransferDetailsToEmail];
}
